import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import fieldCategoryStore from './store';
import userStore from '@/store/user';
import { Tooltip } from 'antd';
import EE from '@/common/event';
import aiSearchHomeStore from '@/pages/search-home/store';

import './index.scss';
import genFileTypesStore from '@/pages/search-home/components/gen-file-types/store';
import homeSimpleAgentsStore from '@/pages/search-home/components/simple-agents/store';

const FieldCategory = ({ className = '' }) => {
  const { categories } = fieldCategoryStore;

  const handleClick = (index, item) => {
    const { title, icon, category } = item;
    aiSearchHomeStore.setShowCustomInputPage(true);
    
    if (!userStore.isUser) {
      userStore.gotoLogin();
      return;
    }
    EE.emit('chat_input_focus');
    fieldCategoryStore.checkCategory(index);
    genFileTypesStore.reset();
    homeSimpleAgentsStore.reset();
  };

  return (
    <div className='h-40px w-full relative'>
      <div className={`flex h-40px gap-6px justify-center w-100vw absolute left-[50%] translate-x-[-50%] transform z-1000 ${className}`}>
        {categories?.map((item, index) => {
          const { title, icon, icon_on, intro } = item;
          const isChecked = fieldCategoryStore.isCheckedCategory(index);

          return (
            <Tooltip
              key={index}
              overlayClassName="field-category-tooltip"
              placement="bottom"
              arrow={false}
              align={{ offset: [0, 6] }}
              title={
                intro ? (
                  <div className="text-12px text-black text-opacity-70 leading-17px text-left">
                    {intro}
                  </div>
                ) : null
              }
            >
              <div
                key={index}
                className={['cat-item']}
                style={{
                  marginLeft: `${index === 0 ? 0 : '-2px'}`,
                  zIndex: categories.length - index,
                  color: isChecked ? '#006AFF' : '#000',
                  backgroundColor: isChecked ? '#F0F5FF' : '#FFF',
                  fontWeight: isChecked ? '600' : '400',
                }}
                onClick={() => handleClick(index, item)}
              >
                <div className="flex gap-4px">
                  <img src={isChecked ? icon_on : icon} className="size-14px" />
                  <div className="text-14px">{title}</div>
                  {title === 'AI高考填报助手' && (
                    <>
                      <div className="relative">
                        <div className="absolute top-[-8px] right-[-31px] bg-[#FF3B30] w-[31px] h-[15px] rounded-[15px] text-white px-1.5 py-0 text-[11px] font-bold flex items-center justify-center text-center leading-none">
                          New
                        </div>
                      </div>
                      <div className='w-[31px]'></div>
                    </>
                  )}
                </div>
              </div>
            </Tooltip>
          );
        })}
      </div>
    </div>
  );
};

export default observer(FieldCategory);
